module.exports = __webpack_public_path__ + "img/logo-white.6ea723a6.svg";